import { Box } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import Expander from "./Expander/Expander";
import Resizer from "./Resizer/ReSizer";
const RightPanelFeaturesContainer = withStyles({
    root: {
        width: "15px",
    },
})(Box);
const RightPanelFeatures = ({ dockedActive, }) => {
    return dockedActive ? (<RightPanelFeaturesContainer>
      <Resizer dockedActive={dockedActive}/>
      <Expander dockedActive={dockedActive}/>
    </RightPanelFeaturesContainer>) : null;
};
export default RightPanelFeatures;
